import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
import  { Logger } from 'aws-amplify';
import moment from 'moment-timezone'

Vue.use(Vuex)

const logger = new Logger('StoreJs','INFO');

export default new Vuex.Store({
    plugins: [createPersistedState()],
    state: {
        menu: {},
        testMode:false,
        placeIdParam:"", // this is actually premiseId
        shopName:"",
        location:{},//premiseData location only
        appReady:false,
        deliveryProvider:{},
        customer:{},//for permanent data such as name,email,phone
        userSelect:{},
        cartCurrent:{},
        currentOrder:{},
        suspendUntil:{},
        permanentlyClosed:false,
    },
    getters: {
        businessHours:(state) => (currentMoment) =>{
            return getBusinessHours(state.menu.defalutSettings.serviceProvided,state.menu.businessHours,currentMoment)
        },
        getDeliveryProvider:(state) => {
            return state.deliveryProvider
        }
    },
    mutations: {
        setPermanentlyClosedMT(state,val){
            state.permanentlyClosed = val

        },
        setSuspendUntilMT(state,val){
            state.suspendUntil = val
        },
        initalizeMT(state){
            state.menu = {}
            state.placeIdParam = ""
            state.location = {}
            state.appReady = false
        },
        setTestModeMT(state,val){
            state.testMode = val
        },
        setMenuMT(state,val){
            state.menu = val
        },
        setPlaceIdParamMT(state,val){
            state.placeIdParam = val
        },

        setShopNameMT(state,val){
            state.shopName = val
        },
        setLocationMT(state,loc){
            state.location = loc
        },
        setAppReadyMT(state,val){
            state.appReady = val
        },
        setDeliveryProviderMT(state,val){
            state.deliveryProvider = val
        },
        setCustomerMT(state,val){
            state.customer = val
        },
        setUserSelectMT(state,val){
            state.userSelect = val
        },
        setCartCurrentMT(state,val){
            state.cartCurrent = val
        },
        setCurrentOrderMT(state,val){
            state.currentOrder = val
        },
    },
    actions: {
        initialize(context){
            context.commit('initalizeMT')
        },
        setMenu(context,val){
            logger.info("store.js setMenu")
            context.commit('setMenuMT',val)
        },
        setPlaceIdParam(context,val){
            logger.info("store.js setPlaceIdParamMT",val)
            context.commit('setPlaceIdParamMT',val)
        },

        setShopName(context,val){
            context.commit('setShopNameMT',val)
        },
        setLocation(context,val){
            const loc = {}
            loc.googlePlaceId = val.googlePlaceId
            loc.lat = val.geometry.location.lat
            loc.lng = val.geometry.location.lng
            context.commit('setLocationMT',loc)
        },
        setAppReady(context,val){
            context.commit('setAppReadyMT',val)
        },
        setDeliveryProvider(context,val){
            context.commit('setDeliveryProviderMT',val)
        },
        setCustomer(context,val){
            context.commit('setCustomerMT',val)
        },
        setUserSelect(context,val){
            context.commit('setUserSelectMT',val)
        },
        setCartCurrent(context,val){
            context.commit('setCartCurrentMT',val)
        },
        setCurrentOrder(context,val){
            context.commit('setCurrentOrderMT',val)
        },
    },

})


const getBusinessHours = (services,businessHours,currentMoment) => {

    const numberOfBusinessDayNeedToFind = 36

    const res = {}

    res.dayTextLang = dayTextLang(numberOfBusinessDayNeedToFind)

    for (let j in services) {
        const targetService = services[j]
        let isOpen = false
        let businessHoursText = ""
        let dayTextAll = ""
        const days = []


        for (let i = 0; i <= numberOfBusinessDayNeedToFind; i++) {
            const targetDay = currentMoment.clone().add(i, 'days')
            const dayString = targetDay.format("Y-MM-DD")
            //logger.info("getBusinessHours",dayString)
            if (!businessHours[dayString]) {
                //logger.info("getBusinessHourByRule",dayString)
                const hoursByRule = getBusinessHourByRule(businessHours, dayString)
                if (hoursByRule) {
                    businessHours[dayString] = hoursByRule
                }
            }

            //console.log('checking business day after ' + i +' days: ' + targetDay.format("Y-MM-DD"))
            if (i <= 1 || businessHours[dayString] && businessHours[dayString][targetService].length > 0) {
                //console.log("found buziness day")

                const bizHourRes = getDayDetail(businessHours, dayString, targetService, i)
                //logger.info("bizHoursRes: ",bizHourRes)
                dayTextAll += bizHourRes.text
                if (bizHourRes.isOpen) {
                    isOpen = true
                }
                days.push(bizHourRes)

            }else{
                days.push({})
            }
        }

        businessHoursText += currentMoment.format('llll') + "現在、"
        if (isOpen) {
            businessHoursText += "営業中です。\n"
        } else {
            businessHoursText += "営業時間外です。\n"
        }
        businessHoursText += " "
        businessHoursText += dayTextAll

        let titleJa = ""
        switch (targetService) {
            case "adt":
                titleJa = "お車にお届け"
                break;
            case "dineIn":
                titleJa = "店内予約"
                break;
            case "pickUp":
                titleJa = "持帰り予約"
        }

        res[targetService] = {}
        res[targetService].isOpen = isOpen
        res[targetService].businessHoursText = businessHoursText
        res[targetService].days = days
        res[targetService].titleJa = titleJa


    }

    //

    //logger.info("businessHours", res)


    return res
}

const make4digitTime = (str) => {
    const strArray = str.split(":")
    let res = ""
    for(let i in strArray){
        const digit = strArray[i]
        if(digit.length == 1){
            res += "0" + digit
        }else{
            res += digit
        }
        if(i != strArray.length - 1){
            res += ":"
        }
    }
    return res
}

const getDayDetail = (businessHours,dayText,targetService,distanceToToday) =>{
    const res = {}
    res.distanceToToday = distanceToToday
    res.dayTextLang = moment(dayText).format('M月D日(dd)')
    let text = ""

    switch(distanceToToday){
        case 0:
            res.calendarText = "本日"
            break
        case 1:
            res.calendarText = "明日"
            break
        case 2:
            res.calendarText = "明後日"
            break
        case 3:
            res.calendarText = "明々後日"
            break
        default:
            res.calendarText = distanceToToday + "日後"
    }

    if(businessHours[dayText]){
        const ranges = businessHours[dayText]
        //logger.info("ranges",ranges[targetService])
        res.ranges = ranges[targetService]
        res.isBusinessDay = true
        res.dayText = dayText



        text += res.calendarText
        text += " "

        text += res.dayTextLang
        text += "の営業時間は、"
        res.rangesLang = []
        res.times = {}
        res.timeName = {}

        for(let i in ranges[targetService]){
            const range = ranges[targetService][i]
            const rangeArray = range.split('-')
            const start =  dayText + "T" + make4digitTime(rangeArray[0]) + ":00+09:00"

            //logger.info("start",start)
            const startMoment = moment( moment(start) )
            let end =  dayText + " " + rangeArray[1]
            // if end time is more than 23:59 eg 27:00 = 3am next day
            const endTimeArray = rangeArray[1].split(':')
            const first2digitsOfEnd = parseInt( endTimeArray[0] )
            //logger.info("first2digitsOfEnd",first2digitsOfEnd)
            if(first2digitsOfEnd > 23){
                const nextDayText = moment(dayText).add(1,'day').format("Y-MM-DD")
                let timeNextDay = first2digitsOfEnd - 24
                if(timeNextDay<10){
                    timeNextDay = "0" + timeNextDay
                }
                end = nextDayText + "T" + timeNextDay + ":" + endTimeArray[1] + ":00+09:00"
            }
            //logger.info("end",end)
            const endMoment = moment( moment(end) )

            const lang = {}
            lang.start = moment(start).format('Ah時') + showMin(start)
            lang.end = moment(end).format('Ah時') + showMin(end)
            lang.startEnd = lang.start + "から" + start + lang.end
            res.rangesLang.push(lang)
            const duration = endMoment.diff(startMoment,'minutes')
            const numTimes = Math.floor( duration / 15 )


            const targetMoment = moment( moment(start) )
            for(let j=0;j<=numTimes;j++){
                let target
                if(j==0){
                    target = targetMoment
                }else{
                    target = targetMoment.add( 15,'minutes')
                }

                const hour = target.format("H")
                if(j==0 && !res.times.startHour){
                    res.times.startHour = hour
                }
                if(j == numTimes ){
                    res.times.endHour = hour
                }
                if(!res.times[hour]){
                    res.times[hour] = []
                }
                res.times[hour].push(target.format("HH:mm"))
                if(!res.timeName[hour]){
                    res.timeName[hour] = target.format('Ah時')
                }
            }



            text += lang.startEnd

            if(i != ranges[targetService].length - 1){
                text += "と"
            }

            if( moment().isBetween(start,end) ){
                res.isOpen = true
                res.timeToClose = endMoment.diff(moment(),'minutes')
                if(i < ranges[targetService].length - 1){
                    res.willOpenAgain = true
                }else{
                    res.willOpenAgain = false
                }
            }
            //beforeOpen = false
            //let closedAlready = false
            //let willOpen = false
            //let startOnDay = ""
            //let endOnDay = ""
            if(i==0){
                if(moment().isBefore(start) ){
                    res.beforeOpen = true
                    res.timeToOpen = startMoment.diff(moment(),'minutes')
                }
            }
            if(i== ranges[targetService].length - 1 ){
                if(moment().isAfter(end) ){
                    res.closedAlready = true
                }else{
                    res.closedAlready = false
                    res.timeToCompletelyClose = endMoment.diff(moment(),'minutes')
                }
            }
        }
        text += "です。\n"
    }else{
        res.isBusinessDay = false
        text += moment(dayText).format('M月D日(dd)')
        text += "はお休みです。\n"
    }



    res.text = text
    return res
}


const showMin = (timeText) => {
    let res
    if(moment(timeText).format('m') == '0'){
        res = ""
    }else{
        res = moment(timeText).format('m分')
    }
    return res
}


const getBusinessHourByRule = (businessHours,dayString) => {
    //logger.info("dayString",dayString)
    const momentOfTheDay = moment(dayString)
    const dayNum = momentOfTheDay.format('E')
    let patternId = businessHours.patterns["day"+dayNum]

    //holidays
    const holidays={}
    for(let i in businessHours.holidays){
        const holidayArray = businessHours.HolidayDetail[businessHours.holidays[i]]
        for(let dayText in holidayArray){
            holidays[dayText] = holidayArray[dayText]
        }
    }
    //logger.info("holidays",holidays)
    //override on the holiday
    if(holidays[dayString]){
        patternId = businessHours.patterns["HolidayIs"+dayNum]
        //logger.info("holiday on " + dayNum )
    }

    //override day next holiday
    const aDayAfterHoliday = momentOfTheDay.add(-1,'day')
    const aDayAfterHolidayYmd = aDayAfterHoliday.format('Y-MM-DD')
    //console.log("aDayAfterHolidayYmd: " + aDayAfterHolidayYmd)
    if(holidays[aDayAfterHolidayYmd]){
        patternId = businessHours.patterns["ADayAfterHolidayIs"+dayNum]
    }

    //override day before holiday
    const aDayBeforeHoliday = momentOfTheDay.add(2,'day')
    const aDayBeforeHolidayYmd = aDayBeforeHoliday.format('Y-MM-DD')
    //console.log("aDayBeforeHolidayYmd: " + aDayBeforeHolidayYmd)
    if(holidays[aDayBeforeHolidayYmd]){
        patternId = businessHours.patterns["ADayBeforeHolidayIs"+dayNum]
    }


    if(patternId && businessHours.PatternDetail[patternId]){
        return businessHours.PatternDetail[patternId]
    }else{
        return false
    }
}


const dayTextLang = (maxDays) =>{
    const res=[]
    for(let i=0;i<=maxDays;i++){
        const targetDay = moment().add(i,'days')
        const dayText = {}
        dayText.key = i
        dayText.ymd = targetDay.format("Y-MM-DD")
        dayText.ymdLocal = {}
        targetDay.locale('ja')
        dayText.ymdLocal["ja-JP"] = targetDay.format('M月D日(dd)')
        targetDay.locale('en')
        dayText.ymdLocal["en-US"] = targetDay.format('M/D(dd)')
        targetDay.locale('zh-hk')
        dayText.ymdLocal["zh-MO"] = targetDay.format('M/D(dd)')
        targetDay.locale('zh-cn')
        dayText.ymdLocal["zh-CN"] = targetDay.format('M/D(dd)')
        dayText.calendar ={}
        switch(i){
            case 0:
                dayText.calendar["ja-JP"] = "本日"
                dayText.calendar["en-US"] = "Today"
                dayText.calendar["zh-MO"] = "今天"
                dayText.calendar["zh-CN"] = "今天"
                break
            case 1:
                dayText.calendar["ja-JP"] = "明日"
                dayText.calendar["en-US"] = "Tomorrow"
                dayText.calendar["zh-MO"] = "明天"
                dayText.calendar["zh-CN"] = "明天"
                break
            case 2:
                dayText.calendar["ja-JP"] = "明後日"
                dayText.calendar["en-US"] = "Day after tomorrow"
                dayText.calendar["zh-MO"] = "後天"
                dayText.calendar["zh-CN"] = "後天"
                break
            default:
                dayText.calendar["ja-JP"] = i + "日後"
                dayText.calendar["en-US"] = i + " days later"
                dayText.calendar["zh-MO"] = i + "天后"
                dayText.calendar["zh-CN"] = i + "天后"
        }
        res.push(dayText)

    }
    return res
}
